'use client';

import type { Project } from '@/types/project';
import { CircleCheck } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { CompactSection, RequiredIndicator } from './section-components';

interface ProjectGoalsSectionProps {
  project: Project;
  projectId: string;
}

export function ProjectGoalsSection({
  project,
  projectId,
}: ProjectGoalsSectionProps) {
  const t = useTranslations('project');
  const tGoals = useTranslations('projectGoals');

  const goalsText =
    project.attributes.goals_ai?.trim() ||
    project.attributes.goals?.trim() ||
    '';

  return (
    <CompactSection
      title={t('projectGoals')}
      href={`/project/${projectId}/goals`}
      contextContent={
        goalsText ? (
          // Filled goals show a teal unfilled checkmark as a status badge —
          // mirrors the render-settings Project goals row.
          <CircleCheck
            className="h-5 w-5 text-primary"
            strokeWidth={1.5}
            aria-label={tGoals('set')}
          />
        ) : (
          <RequiredIndicator />
        )
      }
    />
  );
}
